import image1 from '../Home/images/Mobile_app_perspective_matte.png';
import image2 from '../Home/images/Dashboard_perspective_matte.png';

export const ServicesData=[
    {
    image:image1,
    title:'Web Design & Development',
    description:'A Website is an extension of yourself and we can help you to express it properly. Your website is your number one marketing asset because we live in a digital age.'
},
    {
    image:image2,
    title:'Software Testing Service',
    description:'A Website is an extension of yourself and we can help you to express it properly. Your website is your number one marketing asset because we live in a digital age.'
},
    {
    image:image1,
    title:'Mobile App Development',
    description:'A Website is an extension of yourself and we can help you to express it properly. Your website is your number one marketing asset because we live in a digital age.'
},
{
    image:image1,
    title:'Software Testing Service',
    description:'A Website is an extension of yourself and we can help you to express it properly. Your website is your number one marketing asset because we live in a digital age.'
},
{
image:image2,
title:'Mobile App Development',
description:'A Website is an extension of yourself and we can help you to express it properly. Your website is your number one marketing asset because we live in a digital age.'
},
]